export default {
  setPostsFilesClicks(state, payload) {
    state.postsFilesClicks =payload;
  },
  resetItemCount(state,payload){
    let item = state.postsFilesClicks.find(a => a.id == payload.id);
    item.countOfClicked=0


  }
};
